import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const ProductValueContext = createContext<typeof initialState>(initialState);

const ProductActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { ProductActionContext, ProductValueContext };
